import { EMPTY, of } from "rxjs";
import { delay, filter, switchMap } from "rxjs/operators";
import { utilAnimation } from "../../../utils/animation/utilAnimation";
import { appCanvas } from "../../app/appCanvas";
import { actionPlayerSettingsToggleAnimation, TypeActionPlayerSettingsInfo, } from "../../info/player-settings/actionPlayerSettingsInfo";
export var epicAutoSetAnimation = function (action$, state$) {
    return action$.pipe(filter(function (action) {
        return action.type === TypeActionPlayerSettingsInfo.SetAutoAnimation;
    }), delay(3500), switchMap(function () {
        var animationSetting = state$.value.playerSettingsInfo.animationEnabled;
        var shouldPlayAnim = utilAnimation.shouldPlayAnimation();
        if (shouldPlayAnim !== animationSetting) {
            var fpsLimit = shouldPlayAnim ? 60 : 30;
            utilAnimation.setAnimationSettings(shouldPlayAnim, true, fpsLimit);
            appCanvas.removeUpdate();
            appCanvas.startUpdate(fpsLimit);
            return of(actionPlayerSettingsToggleAnimation(shouldPlayAnim));
        }
        return EMPTY;
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/animation/epics/epicAutoSetAnimation.ts
// module id = 1762
// module chunks = 3